import React from "react";
import { Modal } from "~/components/modal";
import { Container } from "./styles";
export const Popup = ({
  children,
  isShow,
  onClose
}) => /*#__PURE__*/React.createElement(Modal, {
  open: isShow,
  onClose: onClose,
  "data-qa": "popup"
}, /*#__PURE__*/React.createElement(Container, null, children));
Popup.displayName = "Popup";